export default "/_next/static/images/img3-0fe9f9fd13ee072e178133fa41cc59b5.png";